import cx from 'classnames'
import { CommandPaletteFilter } from './types'
import styles from './CommandPaletteFilters.module.css'

interface CommandPaletteFiltersProps {
  filters: CommandPaletteFilter[]
  activeFilter: string
  onFilterChange: (filterId: string) => void
}

export function CommandPaletteFilters({
  filters,
  activeFilter,
  onFilterChange,
}: CommandPaletteFiltersProps) {
  return (
    <div className={styles.CommandPaletteFilters} role="group" aria-label="Filter results">
      {filters.map((filter) => (
        <button
          key={filter.id}
          type="button"
          className={cx(styles.CommandPaletteFilters__pill, {
            [styles.isActive]: activeFilter === filter.id,
          })}
          onClick={() => onFilterChange(filter.id)}
          aria-pressed={activeFilter === filter.id}
        >
          {filter.label}
        </button>
      ))}
    </div>
  )
}
